import * as _ from "lodash";
import { Components } from "formiojs";
import * as moment from "moment";

const DatagridComponent = Components.components.datagrid;

export default class MiproEpisodeNotesDataGrid extends DatagridComponent {

    static schema() {
        return DatagridComponent.schema({
            type: "miproEpisodeNotesDatagrid",
            label: "Episode Notes",
            key: "dbo.mipro.miproEpisodeNotesDatagrid",
            disableAddingRemovingRows: true,
            components: [
                {
                    "label": "Date",
                    "tableView": false,
                    "disabled": true,
                    "datePicker": {
                        "disableWeekends": false,
                        "disableWeekdays": false
                    },
                    "timePicker": {
                        "showMeridian": false
                      },
                    "enableMinDateInput": false,
                    "enableMaxDateInput": false,
                    "key": "ENLastUpdatedDate",
                    "type": "datetime",
                    "input": true,
                    "useLocaleSettings": true,
                    "format": "dd-MM-yyyy HH:mm",

                    "widget": {
                        "type": "calendar",
                        "displayInTimezone": "viewer",
                        "locale": "en",
                        "useLocaleSettings": true,
                        "allowInput": true,
                        "mode": "single",
                        "enableTime": true,
                        "noCalendar": false,
                        "format": "dd-MM-yyyy HH:mm",
                        "hourIncrement": 1,
                        "minuteIncrement": 1,
                        "time_24hr": true,
                        "minDate": null,
                        "disableWeekends": false,
                        "disableWeekdays": false,
                        "maxDate": null
                    }
                },
                {
                    type: "textarea",
                    key: "ENEpisodeName",
                    label: "Episode",
                    "disabled": true,
                    input: true
                },
                {
                  type: "textarea",
                  key: "ENNotes",
                  label: "Notes",
                  "disabled": true,

                  input: true
                },
              ]
        });
    }

    init() {
        super.init();
    }

    attach(element) {
        super.attach(element);

        var value = this.getValue();
        if (Array.isArray(value) && value.length > 0) {
            const updatedDateUTC = value[0].ENLastUpdatedDate;

            if (updatedDateUTC) {
                const localDate = moment.utc(updatedDateUTC, "YYYY-MM-DD HH:mm").local().format("YYYY-MM-DD HH:mm");
                value[0].ENLastUpdatedDate = localDate;
                this.setValue(value, {});
            }
        }
    }

    static get builderInfo() {
        return {
            title: "ORB EpisodeNotes",
            group: "basic",
            icon: "table",
            weight: 70,
            schema: MiproEpisodeNotesDataGrid.schema(),
        };
    }

}

Components.addComponent("miproEpisodeNotesDatagrid", MiproEpisodeNotesDataGrid);